module.exports = __webpack_public_path__ + "static/media/bushu-06.b4d6c540.png";